/**
 * LoadingState - Centered loading indicator with optional message.
 * Use for full-section or full-screen loading states.
 */

import React from 'react';
import { View, ActivityIndicator } from 'react-native';
import { Text } from '@gluestack-ui/themed';
import { FS_SM, colors } from '../../theme';
import { useDisplayTheme } from '../../hooks/useDisplayTheme';

interface LoadingStateProps {
  /** Optional message displayed below the spinner */
  message?: string;
  /** Spinner size — defaults to 'large' */
  size?: 'small' | 'large';
  testID?: string;
}

export const LoadingState = React.memo(function LoadingState({
  message,
  size = 'large',
  testID,
}: LoadingStateProps) {
  const { theme, fontScale, ffs } = useDisplayTheme();

  return (
    <View
      testID={testID}
      style={{ paddingVertical: 40, alignItems: 'center', paddingHorizontal: 20 }}
    >
      <ActivityIndicator size={size} color={colors.primary} />
      {message ? (
        <Text
          allowFontScaling={false}
          style={{
            fontSize: FS_SM * fontScale,
            color: theme.textSecondary,
            marginTop: 12,
            textAlign: 'center',
            ...ffs,
          }}
        >
          {message}
        </Text>
      ) : null}
    </View>
  );
});
